// extracted by mini-css-extract-plugin
export default {"customBtn":"kymL5Fb5doZY8658_4sc"};